export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/9efedd6f8d84b8cf11b1862201b47d04.svg";